<script setup>
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  class: { type: String, default: '' },
});
</script>

<template>
  <thead :class="cn('[&_tr]:border-b', props.class)">
    <slot />
  </thead>
</template>
